

export const TableStatus = {
    OPEN: 0,
    SITTING: 1,
    BILLING: 2,
}